import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, Label, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { NumericFormat } from "react-number-format";
import { useContext, useEffect, useState } from 'react';
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useBuyToken, useGetCurrency, useChooseCurrency, useBonus, usePawaPay, usePaymentAvailable, useGetaddminaddress } from './api/buyTokenApi';
import { useGetProfile } from '../Myprofile/api';
import TimerContext from '../TimerContext/Timercontext';
import { generateRandomString, generateSecureRandomNumber } from '../../utils/randomString';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../../Loader/buttonLoad';
import { useNavigate } from 'react-router-dom';
import { useGetPreSales, useGetSales } from '../Dashboard/api';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../hook/usetoast';
import {
    useConnect,
    useAccount,
    useSwitchNetwork,
    useDisconnect,
    useNetwork,
    useSendTransaction,
   

} from "wagmi";

import {watchAccount} from "@wagmi/core";

import { chainId } from '../web3/chain';

import {  parseEther } from 'viem'
import { useGetEthBalance, useGetTokenBalance } from '../../hook/balance';


const BuyToken = (props) => {
    const toast = useToast()

    const [activeTab, setActiveTab] = useState('1');
    const toggle = tab => {

        if (activeTab !== tab) setActiveTab(tab);

        
    }
    const [modal, setModal] = useState(false);
    const [paymentModal, setPaymentModal] = useState(false);
    const toggleCnWal = () => setModal(!modal);
    const toggleWdMdl = () => setPaymentModal(!paymentModal)

    const { days, hours, minutes, seconds, visible, endtime, presalevalue } = useContext(TimerContext)
    const naviagte = useNavigate()
    const { t } = useTranslation();

    const validationSchema = yup.object().shape({
        phoneNumber: yup.string()
            .required(t('Phone number is required'))
            .matches(/^\d+$/, t('Phone number must be a number')),

        amount: yup.number()
            .required(t('Amount is required'))
            .positive(t('Amount must be a positive number'))
            .typeError(t('Amount must be a number')),
        reference: yup.string()
            .required('reference is required')
            .min(5, t('minimum 5 characters required'))
            .max(22, t('Reference cannot exceed 26 characters'))
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(validationSchema),
    });


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-GB', options).toUpperCase();

        // Remove commas
        return formattedDate.replace(',', '');
    };
    const { data: getCurrency } = useGetCurrency();
    const { data: getBonus } = useBonus();
    const { data: getSalesProgress } = useGetSales()
    const { data: getPreSales } = useGetPreSales();


    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [selectedCrypto, setSelectedCrypto] = useState('BNB');
    const { balance: userBalance } = useGetEthBalance(selectedCrypto);
    const { balance: userBalances } = useGetTokenBalance();
    console.log("🦁 ~ BuyToken ~ ethBalance:", userBalance)
    console.log("🦁 ~ BuyToken ~ userBalances:", userBalances)
    let selectcrypto = getCurrency?.data?.find(currency => currency?.currency_details?.currency_code === selectedCrypto)
    const [cryptoBonus, setCryptoBonus] = useState({
        bonuspercentage: null,
        bonusamount: null,
        totalamount: null,
        selectedprice: selectcrypto?.kkogprice 

    });

    const handleSelect = (crypto) => {
        setSelectedCrypto(crypto);
        setFromValue(0)
        setToValue(0)
       
        console.log("🦁 ~ handleSelect ~ selectcrypto:", selectcrypto?.kkogprice)
        setCryptoBonus({
            bonuspercentage: 0,
            bonusamount: 0,
            totalamount: 0,
            selectedprice: selectcrypto?.kkogprice
        });



    };



    const [chooseCurrency, setChooseCurrency] = useState(getCurrency?.data?.currency_details?.currency_symbol)
    const { data: listCurrency } = useChooseCurrency({ currencySymbol: chooseCurrency?.currency_details?.currency_symbol })
    console.log("🦁 ~ BuyToken ~ listCurrency:", listCurrency)
    const { data: adminaddress, isLoading: loadingadminaddress } = useGetaddminaddress()

    const { data: getProfie, isLoading } = useGetProfile()
    const userPayment = usePawaPay()

    const paymentAvailable = usePaymentAvailable()
    const [availPayment, setAvailPayment] = useState()
    const [value1, setValue1] = useState('');

    const [inrAmount, setInrAmount] = useState(0);

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [payment, setPayment] = useState()
    const [paymentType, setPaymentType] = useState()

    const [result, setResult] = useState(0);
    const [resultCrypto, setResultCrypto] = useState(0);



    const [progressbar, setProgressbar] = useState({
        progressone: false,
        prgresstwo: false,
        currentvalue: 0

    });


    const [progressbarcrypto, setProgressbarcrypto] = useState({
        progressone: false,
        prgresstwo: false,
        currentvalue: 0

    });




    useEffect(() => {
        const selectedPaymentMethod = availPayment?.data?.available_payments[0] === ' M-Pesa' ? "MPESA" : availPayment?.data?.available_payments[0];
        setSelectedPaymentMethod(selectedPaymentMethod);

        setPayment(availPayment?.data?.supportedCorres);

        const matchingPayment = availPayment?.data?.supportedCorres?.find((item) => {
            if (selectedPaymentMethod === 'M-Pesa') {
                return "MPESA_".split('_').some(word => item.includes(word));
            } else {
                return selectedPaymentMethod?.split('_').some(word => item.includes(word));
            }
        });


        setPaymentType(matchingPayment);
    }, [availPayment]);
    const filteredCurrencyList = getCurrency?.data?.filter((item) => item?.currency_details.type === 'fiat') || [];
    



    useEffect(() => {
        
        if (getCurrency?.data?.length > 0 && selectedCurrency === null) {
            const defaultCurrency = getCurrency.data.find(currency => currency.currency_details?.currency_code ===  'NGN');
            if (defaultCurrency) {
                setSelectedCurrency(defaultCurrency);
                setChooseCurrency(defaultCurrency);
                availableCode(defaultCurrency)
            } else {
                setSelectedCurrency(getCurrency.data[0]);
                setChooseCurrency(getCurrency.data[0]);
            }
        }
    }, [getCurrency?.data, selectedCurrency,activeTab]);

    const [bonus, setBonus] = useState({
        bonuspercentage: null,
        bonusamount: null,
        totalamount: null,

    });





    const handleCurrencyClick = async (currency) => {
        setSelectedCurrency(currency);
        setValue1('');
        setInrAmount(0)
        reset({
            phoneNumber: '',
            reference: ''
        })
        await availableCode(currency)
    };



    const availableCode = async (data) => {
        setIsloading(true)

        try {
            const response = await paymentAvailable.mutateAsync({ countryCode: data?.currency_details?.country_code })

            setAvailPayment(response)
        } catch {
            setIsloading(false)

        } finally {
            setIsloading(false)
        }

    }
    const handleChooseCurrency = (currency) => {
        setChooseCurrency(currency)
    }


    const [slab, setSlab] = useState([]);

    useEffect(() => {
        if (getBonus?.data) {
            setSlab(getBonus?.data.filter(item => item.type === 'slab'));
        }
    }, [getBonus]);



    const [isedit, setIsedit] = useState(false)
    const toggleEdit = () => {
        setIsedit(!isedit)
    }

  


    //--------- Post Sale Calculation --------//

    const postPurchased = getSalesProgress?.data?.totalPurchased;
    const postSupply = getSalesProgress?.data?.totalSupply

    const availablePostTokens = postSupply - postPurchased

    const salePercentage = postSupply > 0 ? (availablePostTokens / postSupply) * 100 : 0


    //-----Pre Sale Calculation --------//

    const prePurchased = getPreSales?.data?.totalPurchased;
    const preSupply = getPreSales?.data?.totalPreSupply

    const availablePreTokens = preSupply - prePurchased

    const presalePercentage = preSupply > 0 ? (availablePreTokens / preSupply) * 100 : 0





    const findRewardPercentage = (value) => {

        const range = slab.find((item) => value >= item.bonusRangefrom && value <= item.bonusRangeto)
        return range ? range.rewardpercentage : 0;
    };


    const handleValueChange = (e) => {
        const value = e.target.value;

        setProgressbar({ currentvalue: value })

        // const inr = value ? parseFloat(value) / selectedCurrency?.kkogprice : 0;
        // const inr =  selectedCurrency?.kkogprice  ;
           const inr = value ? parseFloat(value) * selectedCurrency?.kkogprice : 0;

        const matchingSlab = findRewardPercentage(value);
        setIsButtonDisabled(false);

        setResult(value * matchingSlab / 100);

        setValue1(value);

        setInrAmount(inr);

        const bonusPercentage = visible ? value * (presalevalue / 100) : 0


        const bonusAmount = getPreSales?.data?.isActive === 'active' ? bonusPercentage + (+value * matchingSlab / 100) : value * matchingSlab / 100

        const totalAmount = getPreSales?.data?.isActive === 'active' ? bonusPercentage + value * matchingSlab / 100 + Number(value) : value * matchingSlab / 100 + Number(value)


        // Update bonus state with new calculations
        setBonus({
            bonuspercentage: bonusPercentage,
            bonusamount: bonusAmount,
            totalamount: totalAmount,
        });



        if (totalAmount > availablePostTokens || totalAmount > availablePreTokens) {
            setIsButtonDisabled(true);
            toast.error("Entered token value is greater than total supply");
        }

    };


    const handlePaymentMethodChange = (event) => {
        const method = event.target.value;
        const matchingPayment = payment?.find((item) => {
            return method.split('_').some(word => item.includes(word));
        });
        setPaymentType(matchingPayment)
        setSelectedPaymentMethod(method);
    };


    const userBuy = useBuyToken()
    const { isloading, setIsloading } = useModalContext();
    const presaleActive = getPreSales?.data?.isActive == 'active'
    const [randomData, setRandomData] = useState(Math.floor(100000 + generateSecureRandomNumber() * 900000))


    const onSubmit = async (data) => {
        setIsloading(true)
        try {

            const isNewUser = getProfie?.data?.newUser; // true or false

            const referredId = getProfie?.data?.referredBy //reffreal

            let referralCode = '';

            if (isNewUser) {
                referralCode = generateRandomString(7)

            }

            const totalPurchaseAmount = value1;
            let referralFee = 0;

            if (isNewUser && referredId) {
                referralFee = totalPurchaseAmount * 0.02;
            }
            const buyData = {
                amount: parseFloat(inrAmount),
                currency: selectedCurrency?.currency_details?.currency_code,
                email: getProfie?.data?.email,
                description: data?.reference,
                correspondent: paymentType,
                phoneNumber: `${selectedCurrency?.currency_details?.country_code}${data?.phoneNumber}`

            }
            if (selectedPaymentMethod === 'M-Pesa') {
                setIsloading(true)
                const MTNres = await userPayment.mutateAsync(buyData)
                if (MTNres[0]?.status === 'COMPLETED' || MTNres[0]?.status === 'SUBMITTED') {
                    const mtnData = {
                        fromCurrency: selectedCurrency?.currency_details?.currency_symbol,
                        fromAmount: data?.amount,
                        toAmount: value1,
                        paymentType: 'Mpesa',
                        payment: "crypto",
                        bonusLevel: bonus?.bonuspercentage,
                        paymentStatus: "completed",
                        bonusAmount: bonus?.bonusamount,
                        address: getProfie?.data?.walletAddress,
                        totalAmount: bonus?.totalamount,
                        referralCode: referralCode,
                        referralFee: referralFee,
                        saleType: presaleActive ? 'presale' : 'postsale',
                        randomId: randomData,
                        trx_id: MTNres[0]?.depositId

                    }
                    const res = await userBuy.mutateAsync(mtnData)
                    if (res?.status) {
                        setIsloading(false)
                        naviagte('/dashboard')
                        setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                    }
                }
            } else if (selectedPaymentMethod === 'MTN_MOMO') {
                setIsloading(true)
                const MTNres = await userPayment.mutateAsync(buyData)
                if (MTNres[0]?.status === 'COMPLETED' || MTNres[0]?.status === 'SUBMITTED') {
                    const mtnData = {
                        fromCurrency: selectedCurrency?.currency_details?.currency_symbol,
                        fromAmount: data?.amount,
                        toAmount: value1,
                        paymentType: 'MTN',
                        payment: "crypto",
                        bonusLevel: bonus?.bonuspercentage,
                        paymentStatus: "completed",
                        bonusAmount: bonus?.bonusamount,
                        address: getProfie?.data?.walletAddress,
                        totalAmount: bonus?.totalamount,
                        referralCode: referralCode,
                        referralFee: referralFee,
                        saleType: presaleActive ? 'presale' : 'postsale',
                        randomId: randomData,
                        trx_id: MTNres[0]?.depositId

                    }
                    const res = await userBuy.mutateAsync(mtnData)
                    if (res?.status) {
                        setIsloading(false)
                        naviagte('/dashboard')
                        setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                    }
                }
            } else if (selectedPaymentMethod === 'AIRTEL_MONEY') {
                setIsloading(true)
                const MTNres = await userPayment.mutateAsync(buyData)

                if (MTNres[0]?.status === 'COMPLETED' || MTNres[0]?.status === 'SUBMITTED') {
                    const mtnData = {
                        fromCurrency: selectedCurrency?.currency_details?.currency_symbol,
                        fromAmount: data?.amount,
                        toAmount: value1,
                        paymentType: 'Airtel',
                        payment: "crypto",
                        bonusLevel: bonus?.bonuspercentage,
                        paymentStatus: "completed",
                        bonusAmount: bonus?.bonusamount,
                        address: getProfie?.data?.walletAddress,
                        totalAmount: bonus?.totalamount,
                        referralCode: referralCode,
                        referralFee: referralFee,
                        saleType: presaleActive ? 'presale' : 'postsale',
                        randomId: randomData,
                        trx_id: MTNres[0]?.depositId

                    }
                    const res = await userBuy.mutateAsync(mtnData)
                    if (res?.status) {
                        setIsloading(false)
                        naviagte('/dashboard')
                        setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                    }
                }

            }
            else if (selectedPaymentMethod === 'ORANGE_MONEY') {
                setIsloading(true)
                const MTNres = await userPayment.mutateAsync(buyData)

                if (MTNres[0]?.status === 'COMPLETED' || MTNres[0]?.status === 'SUBMITTED') {
                    const mtnData = {
                        fromCurrency: selectedCurrency?.currency_details?.currency_symbol,
                        fromAmount: data?.amount,
                        toAmount: value1,
                        paymentType: 'Orange',
                        payment: "crypto",
                        bonusLevel: bonus?.bonuspercentage,
                        paymentStatus: "completed",
                        bonusAmount: bonus?.bonusamount,
                        address: getProfie?.data?.walletAddress,
                        totalAmount: bonus?.totalamount,
                        referralCode: referralCode,
                        referralFee: referralFee,
                        saleType: presaleActive ? 'presale' : 'postsale',
                        randomId: randomData,
                        trx_id: MTNres[0]?.depositId

                    }
                    const res = await userBuy.mutateAsync(mtnData)
                    if (res?.status) {
                        setIsloading(false)
                        naviagte('/dashboard')
                        setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                    }
                }

            }


        } catch (error) {
            setIsloading(false)
            reset({
                phoneNumber: '',
                reference: ''
            })
            setIsedit(false)

        } finally {
            setIsloading(false)
        }
    }


    function formatNumber(value) {
        if (value >= 1e6) {
            return (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (value >= 1e3) {
            return (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'k';
        }
        return value.toString();


    }

    const { connectAsync, connectors } = useConnect();
    const { disconnectAsync } = useDisconnect();



    const { address, isConnected } = useAccount();
   
    const { chain: network } = useNetwork()
    const chainid = network?.id
    const { switchNetworkAsync } = useSwitchNetwork({
        chainId: chainId.BNB,
        throwForSwitchChainNotSupported: true,
    });

    



    

  
 

    const onConnectWalletClick = async () => {
        setIsloading(true)
        if (isConnected) {



            setIsloading(false)
            toggleCnWal()
         
            
           
            return;
        }

        try {
            setIsloading(true)

            const connectedAccount = await connectAsync({ connector: connectors[0] });


            if (connectedAccount.chain.id !== chainId.BNB) {
                await switchNetworkAsync();
            }
           

            if (getProfie?.data?.walletAddress.toLowerCase() !== connectedAccount.account.toLowerCase()) {
                await disconnectAsync();
                return toast.error(t("Connect User address"));
            }
            toggleCnWal()
            toast.success(t(" Wallet connected successfully"));

            localStorage.setItem("account", connectedAccount.account);

        } catch (error) {
        } finally {
            toggleCnWal()
            setIsloading(false)

        }
            console.log("🦁 ~ onConnectWalletClick ~ address:", address)
    };



    useEffect(() => {
        const unwatch = watchAccount((account) => {
          
            if (account.address?.toLowerCase() ===  isConnected && address?.toLowerCase() || !account.address?.toLowerCase) return;
            if (isConnected) {
                console.log("🦁 ~ unwatch ~ isConnected:", account)
                if (getProfie?.data?.walletAddress.toLowerCase() !== account.address.toLowerCase()) {
                    disconnectAsync();
                  
                    toast.error("Wallet address mismatch. Please reconnect with the registered wallet to proceed.")
                }
            }
        });
      

        return () => {
           unwatch();
        };
    }, [address]);
    


    
   



    // Access sendTransaction from wagmi
    const { data, error, isLoading: metamaskloading, sendTransactionAsync } = useSendTransaction();
    console.log("🚀 ~ BuyToken ~ metamaskloading:", metamaskloading)
    console.log("🚀 ~ BuyToken ~ error:", error)
    console.log("🚀 ~ BuyToken ~ data:", data)



    const tokenby = async () => {
                    console.log("🚀 ~ tokenby ~ fromValue:", typeof(fromValue))

        setIsloading(true);
        const isNewUser = getProfie?.data?.newUser; // true or false

        const referredId = getProfie?.data?.referredBy //reffreal

        let referralCode = '';

        if (isNewUser) {
            referralCode = generateRandomString(7)

        }
      

        const totalPurchaseAmount = value1;
        let referralFee = 0;

        if (isNewUser && referredId) {
            referralFee = totalPurchaseAmount * 0.02;
        }

        try {
            console.log("🦁 ~ tokenby ~ adminaddress:", adminaddress?.address[0]?.admin_address);
            console.log("🦁 ~ tokenby ~ config.request.fromValue:", parseEther(fromValue));

            if(fromValue >  userBalance  ){
                setIsloading(false);
                return toast.error(` Insufficient ${selectedCrypto} Balance`)
            }

            

            if (getProfie?.data?.walletAddress.toLowerCase() !== address.toLowerCase()) {
                setIsloading(false);
                return toast.error("Switch to user account")

            }

            if (!fromValue || !adminaddress) {
                setIsloading(false);
                return toast.error("Something went wrong");
            }

            const targetChainId = selectedCrypto === 'BNB' ? chainId.BNB : chainId.ETH_SEPOLIA;
            // console.log("🦁 ~ tokenby ~ connectedAccount:", connectedAccount)
           
            // Switch network if necessary
            if (chainid !== targetChainId) {
                await switchNetworkAsync(targetChainId);
            }

            
          



            // Set up transaction configuration
            const config = {
                to: adminaddress?.address[0]?.admin_address,
                    value: parseEther(fromValue.toString()),
            };

            // Send transaction using the hook
            const transaction = await sendTransactionAsync(config);
            console.log("🦁 ~ tokenby ~ transaction:", transaction);
            if (transaction) {
                const cryptopayment = {
                    fromCurrency: selectedCrypto,
                    fromAmount: fromValue,
                    toAmount: toValue,
                    paymentType: "crypto",
                    payment: "crypto",
                    bonusLevel: cryptoBonus?.bonuspercentage,
                    paymentStatus: "completed",
                    bonusAmount: cryptoBonus?.bonusamount,
                    address: getProfie?.data?.walletAddress,
                    totalAmount: cryptoBonus?.totalamount,
                    referralCode: referralCode,
                    referralFee: referralFee,
                    saleType: presaleActive ? 'presale' : 'postsale',
                    randomId: randomData,
                    trx_id: transaction.hash

                }
                const res = await userBuy.mutateAsync(cryptopayment)
                if (res?.status) {
                    toast.success("Transaction successful! ");
                    setIsloading(false)
                    naviagte('/dashboard')
                    setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                    setToValue('')
                    setFromValue('')

                    setCryptoBonus({
                        bonuspercentage: 0,
                        bonusamount: 0,
                        totalamount: 0,
                    });


                }

            }




        } catch (error) {
            console.error('Transaction failed:', error);
            toast.error("Transaction failed");
        } finally {
            setIsloading(false);
        }
            console.log("🦁 ~ tokenby ~ address:", address)
            console.log("🦁 ~ tokenby ~ address:", address)
    };



    const [fromValue, setFromValue] = useState();
    const [toValue, setToValue] = useState();



    const handleFromInputChange = (e) => {
        const value = e.target.value;
        setFromValue(value);
       
        let selectcrypto = getCurrency?.data?.find(currency => currency?.currency_details?.currency_code === selectedCrypto)

        const calculatedValue = value / selectcrypto?.kkogprice;
        setToValue(calculatedValue);
        handlecalculation(calculatedValue);
        setProgressbarcrypto({ currentvalue: calculatedValue })



    };

    // Handle change in the "to" input field
    const handleToInputChange = (e) => {
        const value = e.target.value;
        setProgressbarcrypto({ currentvalue: value })
        setToValue(value);

        let selectcrypto = getCurrency?.data?.find(currency => currency?.currency_details?.currency_code === selectedCrypto)
        const calculatedValue = value * selectcrypto?.kkogprice;
        setFromValue(calculatedValue);
        handlecalculation(value)
        console.log("🦁 ~ handlecalculation ~ currentvalue:----------------------------------", progressbarcrypto.currentvalue)
        //

     

    };

        


    const handlecalculation = (value) => {
        setIsButtonDisabled(false);

        let selectcrypto = getCurrency?.data?.find(currency => currency?.currency_details?.currency_code === selectedCrypto)
        const inr = value ? parseFloat(value) / selectcrypto?.kkogprice : 0;
        console.log("🦁 ~ handlecalculation ~ inr:", inr)

        const matchingSlab = findRewardPercentage(value);
        console.log("🦁 ~ handleToInputChange ~ matchingSlab:", matchingSlab)
      
        setResultCrypto(value * matchingSlab / 100);
        console.log("🦁 ~ BuyToken ~ resultCrypto:", resultCrypto)

        const bonusPercentage = visible ? value * (presalevalue / 100) : 0
        console.log("🦁 ~ handleToInputChange ~ bonusPercentage:", bonusPercentage)


        const bonusAmount = getPreSales?.data?.isActive === 'active' ? bonusPercentage + (+value * matchingSlab / 100) : value * matchingSlab / 100
        console.log("🦁 ~ handleToInputChange ~ bonusAmount:", bonusAmount)

        const totalAmount = getPreSales?.data?.isActive === 'active' ? bonusPercentage + value * matchingSlab / 100 + Number(value) : value * matchingSlab / 100 + Number(value)
        console.log("🦁 ~ handleToInputChange ~ totalAmount:", totalAmount)


        // Update bonus state with new calculations
        setCryptoBonus({
            bonuspercentage: bonusPercentage,
            bonusamount: bonusAmount,
            totalamount: totalAmount,
        
        });



        if (totalAmount > availablePostTokens || totalAmount > availablePreTokens) {
            toast.error("Entered token value is greater than total supply");
             setIsButtonDisabled(true);
        }
        //
    }


   


    return (
        <>
            {isloading || loadingadminaddress ? <Loader /> : ""}

            <div className='TrnsctnPg'>


                <div className='row CustRw'>
                    <div className='col-lg-8 CustPad'>
                        <div className="TrnsctnDts">
                            <div className="TrnsctnDtsTp">
                                {/* <h4>{t('Choose Currency and Calculate KKOG Coin Price.')}</h4> */}
                                <h4>Buy Token</h4>
                            </div>
                            <div className='HwTByPg'>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { toggle('1'); }}
                                        >
                                            Crypto
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            Fiat
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <p>{t('You can buy our KKOG coin using the below currency choices to become part of our project. To make a  transaction using a credit card or mobile money. You can use Paypal.')}  </p>
                                <TabContent activeTab={activeTab}>

                                    <TabPane tabId="1">
                                        <div className='CnExchgDv'>
                                            <div className='row justify-content-center'>
                                                <div className='col-lg-8'>
                                                    

                                                    <div className='CnExchgDts'>
                                                        <div className='CnExchgDtsTp'>
                                                            <div className='CnExchgDtsTpL' >
                                                                <label htmlFor='from'>From</label>



                                                                <NumericFormat
                                                                    value={fromValue}
                                                                    className="form-control"
                                                                    placeholder="0.00"
                                                                    allowNegative={false}
                                                                    onChange={handleFromInputChange}
                                                                                                                                    
                                                                    decimalScale={7}
                                                                    allowLeadingZeros={0}


                                                                />
                                                            </div>
                                                            <div className='CnExchgDtsTpR'>


                                                                <UncontrolledDropdown className="CnExchgDtsDD">
                                                                    <DropdownToggle className="CnExchgDtsDDBg">
                                                                        <img src={require(`../../assets/images/${selectedCrypto}.png`)} alt="" />
                                                                        <span className='mx-2'>{selectedCrypto}</span> {/* Display the selected cryptocurrency */}
                                                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9 1L5 5L1 1" stroke="#8F9C67" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </DropdownToggle>
                                                                    <DropdownMenu className="dropdown-menu-right">
                                                                        {/* Update the state when an item is clicked */}
                                                                        <DropdownItem onClick={() => handleSelect('ETH')}>
                                                                            <img src={require('../../assets/images/ETH.png')} alt="" />
                                                                            <span className='ml-2'>ETH</span>
                                                                        </DropdownItem>
                                                                        <DropdownItem onClick={() => handleSelect('BNB')}>
                                                                            <img src={require('../../assets/images/BNB.png')} alt="" />
                                                                            <span className='ml-2'>BNB</span>
                                                                        </DropdownItem>
                                                                        {/* Add more DropdownItems as required for additional cryptocurrencies */}
                                                                    </DropdownMenu>
                                                                </UncontrolledDropdown>
                                                            </div>
                                                        </div>
                                                        <h5>Balance <span>{userBalance} </span> {selectedCrypto} </h5>
                                                    </div>
                                                    <div className='CnExchgDts'>
                                                        <div className='CnExchgDtsTp'>
                                                            <div className='CnExchgDtsTpL'>
                                                                <label htmlFor='tolabel'>To</label>





                                                                <NumericFormat
                                                                    value={toValue}

                                                                    className="form-control"
                                                                    placeholder="0.00"
                                                                    allowNegative={false}
                                                                    onChange={handleToInputChange}
                                                                    maxLength={10}
                                                                    decimalScale={7}
                                                                //allowLeadingZeros={0}

                                                                />
                                                            </div>
                                                            <div className='CnExchgDtsTpR'>
                                                                <div className='CnExchgDtsTpRCnt'>
                                                                    <img src={require('../../assets/images/kkogcoin-mini.png')} alt="" />
                                                                    <span>KKOG</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h5>Balance <span>{userBalances}</span> KKOG </h5>
                                                    </div>


  {(() => {
    if (isConnected && getProfie?.data?.walletAddress) {
      return (
        <button
          type="button"
          className="btn CmnBtn w-100 h-46 my-3"
          onClick={tokenby}
          disabled={
            isloading ||
            fromValue === 0 ||
            fromValue === '' ||
            fromValue === null ||
            isButtonDisabled
          }
        >
          {isloading ? 'Processing...' : 'Buy'}
        </button>
      );
    }

    if (getProfie?.data?.walletAddress) {
      return (
        <button
          className="btn CmnBtn w-100 h-46 my-3"
          onClick={toggleCnWal}
        >
          {t('Connect Wallet')}
        </button>
      );
    }

    return (
      <>
        <button
          className="btn CmnBtn w-100 h-46 my-3"
          onClick={toggleCnWal}
          disabled
        >
          {t('Connect Wallet')}
        </button>
        <span className="text-danger">
          Please update your wallet Address in profile
        </span>
      </>
    );
    
  })()}







                                                    <h6> <span>1</span> {selectedCrypto} <img src={require('../../assets/images/swap.png')} alt='' /> <span>{cryptoBonus?.selectedprice}</span> KKOG</h6>
                                                    <div className='ByTknPrgsBnsBr'>
                                                        {visible ?
                                                            <div className='ByTknPrgsBnsBrBse' style={{ width: `${presalevalue}%` }}>

                                                                <span className="bonus-base-title">{t('Bonus')}</span>
                                                                <span className="bonus-base-amount">{t('On Sale')}</span>
                                                                <span className="bonus-base-percent">{presalevalue}%</span>

                                                            </div>
                                                            : ""}
                                                        {/* {slab.sort((a, b) => a.bonusRangeto - b.bonusRangeto).map((slabItem, index) => (
                                                            <div
                                                                key={slabItem?.rewardpercentage}
                                                                className={progressbarcrypto.currentvalue >= slabItem?.bonusRangeto ? "ByTknPrgsBnsBrExtr" : "ByTknPrgsBnsBrExtrOne"}
                                                                style={{ width: `${slabItem?.rewardpercentage}%` }}
                                                            >
                                                                <div className="bonus-extra-item">
                                                                    <span className="bonus-extra-amount">{formatNumber(slabItem?.bonusRangeto)}<br /> KKOG</span>
                                                                    <span className="bonus-extra-percent">{slabItem?.rewardpercentage} %</span>
                                                                </div>
                                                            </div>
                                                        ))} */}



                                                            {slab
  .sort((a, b) => a.bonusRangeto - b.bonusRangeto)
  .map((slabItem, index) => {
    const prevRange = index === 0 ? 0 : slab[index - 1].bonusRangeto;
    const currentRange = slabItem.bonusRangeto;

    const totalRange = currentRange - prevRange;
    const currentValue = progressbarcrypto.currentvalue;

    let fillPercent = 0;

    if (currentValue >= currentRange) {
      fillPercent = 100; // fully filled
    } else if (currentValue > prevRange) {
      fillPercent = ((currentValue - prevRange) / totalRange) * 100;
    } else {
      fillPercent = 0;
    }

    return (
      <div
        key={slabItem?.rewardpercentage}
        className="ByTknPrgsBnsBrExtrOne"
        style={{
          width: `${slabItem?.rewardpercentage}%`,
          position: "relative",
        //   background: "#e5e5e5",
                background:"#fff",

        }}
      >
        {/* 🔥 Actual Fill */}
        <div
          style={{
            width: `${fillPercent}%`,
            height: "100%",
            background: "#1E4A26",
            borderRadius: "2px",
            transition: "width 0.3s ease",
          }}
        />

        <div className="bonus-extra-item">
          <span
            className="bonus-extra-amount"
            style={index === 1 ? { marginLeft: "14px" } : {}}
          >
            {formatNumber(slabItem?.bonusRangeto)}<br /> KKOG
          </span>

          <span className="bonus-extra-percent">
            {slabItem?.rewardpercentage} %
          </span>
        </div>
      </div>
    );
  })}
                                                    </div>
                                                    <div className='ByTknBnsDv row'>
                                                        <div className='col-lg-4'>
                                                            <div className='ByTknBnsDvDts'>
                                                                <h4>+ {t('Sale Bonus')} {visible ? presalevalue : 0}%</h4>
                                                                <h3>{cryptoBonus.bonuspercentage?.toFixed(8) || (0).toFixed(8)}</h3>

                                                            </div>
                                                        </div>
                                                        <div className='col-lg-4'>
                                                            <div className='ByTknBnsDvDts'>


                                                                <h4>+ {t('Amount Bonus')}</h4>

                                                                <h3>{resultCrypto.toFixed(8) || 0}</h3>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-4'>
                                                            <div className='ByTknBnsDvDts'>
                                                                <h4>{t('Total KKOG')}</h4>
                                                                <h3>{cryptoBonus?.totalamount?.toFixed(8) || (0).toFixed(8)}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className='BuyTknNt text-center'>Your Contribution will be calculated based on exchange rate at the moment your transaction is confirmed.</p>
                                        </div>
                                    </TabPane>

                                    <TabPane tabId="2">

                                        <div className='ByTknSlCrny'>
                                            <label>{t('Select Currency')}</label>
                                            {filteredCurrencyList.length > 0 && (
                                                <div className='row CustRw'>
                                                    {filteredCurrencyList.map((currency) => (
                                                        <button className='EpySty col-lg-6 CustPad' onClick={() => handleCurrencyClick(currency)} key={currency}>
                                                            <div className={`ByTknSlCrnyDts ${selectedCurrency?._id === currency._id ? 'selected' : ''}`}>
                                                                <div className='Ldv'>
                                                                    <img src={currency?.currency_details?.image} alt='' className='ByTknSlCrnyFlg' />
                                                                    <span>{currency?.currency_details?.currency_code}</span>
                                                                </div>
                                                                <div className='Rdv'>
                                                             
                                                                    {/* <span>= {currency.kkogprice} KKOG</span> */}
                                                                    <span>{(1 / currency?.kkogprice).toFixed(6)} KKOG</span>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    ))}
                                                </div>


                                                
                                            )}
                                        </div>
                                        <div className='BytknCnAmt'>
                                            <label>{t('Request Coin Amount')}</label>
                                            <div className='BytknCnAMtVal'>
                                                <div className='BytknCnAMtFctrl'>
                                                    <NumericFormat
                                                        value={value1}
                                                        className="form-control"
                                                        placeholder="0.00"
                                                        allowNegative={false}
                                                        onChange={handleValueChange}
                                                        maxLength={10}
                                                        decimalScale={8}
                                                        allowLeadingZeros={0}

                                                    />
                                                    <span>KKOG</span>
                                                </div>
                                                <h4>= {inrAmount} {selectedCurrency?.currency_details?.currency_symbol}</h4>
                                            </div>
                                        </div>
                                        <div className='BytknSlPymt'>
                                            <label>{t('Select Payment Method')}</label>
                                            <div className='ByTknSlPymtRad'>
                                                {availPayment?.message === 'Payment Methods are not available for your Region' ? (
                                                    <div className="NoPaymentsAvailable">
                                                        <p className='text-danger'>No payment available for your {selectedCurrency?.currency_details?.currency_code} region</p>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {availPayment?.data?.available_payments.includes("M-Pesa") && (
                                                            <div className='ByTknSlPymtRadDts'>
                                                                <label className="CustRadContainer" htmlFor="inputField">
                                                                    <span className="sr-only">M-Pesa</span>
                                                                    <input
                                                                        type="radio"
                                                                        id="inputField"
                                                                        name="paymentMethod"
                                                                        value="M-Pesa"
                                                                        checked={selectedPaymentMethod === 'M-Pesa'}
                                                                        onChange={handlePaymentMethodChange}
                                                                        disabled={!availPayment?.data?.available_payments.includes("M-Pesa")} />
                                                                    <span className="CustRadcheckmark"></span>
                                                                </label>
                                                                <div className='ByTknSlPymtBg'>
                                                                    <img src={require('../../assets/images/mpesa.png')} alt='' />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {availPayment?.data?.available_payments.includes("MTN_MOMO") && (
                                                            <div className='ByTknSlPymtRadDts'>
                                                                <label className="CustRadContainer" htmlFor="mtnField">
                                                                    <span className="sr-only">M-Pesa</span>
                                                                    <input
                                                                        type="radio"
                                                                        name="paymentMethod"
                                                                        id="mtnField"
                                                                        value="MTN_MOMO"
                                                                        checked={selectedPaymentMethod === 'MTN_MOMO'}
                                                                        onChange={handlePaymentMethodChange}
                                                                        disabled={!availPayment?.data?.available_payments.includes("MTN_MOMO")}
                                                                    />
                                                                    <span className="CustRadcheckmark"></span>
                                                                </label>
                                                                <div className='ByTknSlPymtBg'>
                                                                    <img src={require('../../assets/images/mtn.png')} alt='' />
                                                                </div>
                                                            </div>
                                                        )

                                                        }

                                                        {
                                                            availPayment?.data?.available_payments.includes("ORANGE_MONEY") && (
                                                                <div className='ByTknSlPymtRadDts'>
                                                                    <label className="CustRadContainer" htmlFor="orangeField">
                                                                        <span className="sr-only">M-Pesa</span>
                                                                        <input
                                                                            type="radio"
                                                                            name="paymentMethod"
                                                                            id="orangeField"
                                                                            value="ORANGE_MONEY"
                                                                            checked={selectedPaymentMethod === 'ORANGE_MONEY'}
                                                                            onChange={handlePaymentMethodChange}
                                                                            disabled={!availPayment?.data?.available_payments.includes("ORANGE_MONEY")}
                                                                        />
                                                                        <span className="CustRadcheckmark"></span>
                                                                    </label>
                                                                    <div className='ByTknSlPymtBg'>
                                                                        <img src={require('../../assets/images/money.png')} alt='' />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {availPayment?.data?.available_payments.includes("AIRTEL_MONEY") && (
                                                            <div className='ByTknSlPymtRadDts'>
                                                                <label className="CustRadContainer" htmlFor="airtelField">
                                                                    <span className="sr-only">M-Pesa</span>
                                                                    <input
                                                                        type="radio"
                                                                        name="paymentMethod"
                                                                        value="AIRTEL_MONEY"
                                                                        id='airtelField'
                                                                        checked={selectedPaymentMethod === 'AIRTEL_MONEY'}
                                                                        onChange={handlePaymentMethodChange}
                                                                        disabled={!availPayment?.data?.available_payments.includes("AIRTEL_MONEY")}
                                                                    />
                                                                    <span className="CustRadcheckmark"></span>
                                                                </label>
                                                                <div className='ByTknSlPymtBg'>
                                                                    <img src={require('../../assets/images/airtel.png')} alt='' />
                                                                </div>
                                                            </div>
                                                        )

                                                        }
                                                    </>
                                                )}


                                            </div>
                                        </div>

                                        <div className='ByTknPrgsBnsBr'>
                                            {visible ?
                                                <div className='ByTknPrgsBnsBrBse' style={{ width: `${presalevalue}%` }}>

                                                    <span className="bonus-base-title">{t('Bonus')}</span>
                                                    <span className="bonus-base-amount">{t('On Sale')}</span>
                                                    <span className="bonus-base-percent">{presalevalue}%</span>

                                                </div>
                                                : ""}




                                            {slab.sort((a, b) => a.bonusRangeto - b.bonusRangeto).map((slabItem, index) => (
                                                <div
                                                    key={slabItem?.rewardpercentage}
                                                    className={progressbar.currentvalue >= slabItem?.bonusRangeto ? "ByTknPrgsBnsBrExtr" : "ByTknPrgsBnsBrExtrOne"}
                                                    style={{ width: `${slabItem?.rewardpercentage}%` }}
                                                >
                                                    <div className="bonus-extra-item">
                                                        <span className="bonus-extra-amount">{formatNumber(slabItem?.bonusRangeto)}<br /> KKOG</span>
                                                        <span className="bonus-extra-percent">{slabItem?.rewardpercentage} %</span>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>

                                        <div className='ByTknBnsDv row'>
                                            <div className='col-lg-4'>
                                                <div className='ByTknBnsDvDts'>
                                                    <h4>+ {t('Sale Bonus')} {visible ? presalevalue : 0}%</h4>

                                                    <h3>{bonus?.bonuspercentage?.toFixed(2) || 0}</h3>
                                                </div>
                                            </div>
                                            <div className='col-lg-4'>
                                                <div className='ByTknBnsDvDts'>
                                                    <h4>+ {t('Amount Bonus')}</h4>

                                                    <h3>{result || 0}</h3>
                                                </div>
                                            </div>
                                            <div className='col-lg-4'>
                                                <div className='ByTknBnsDvDts'>
                                                    <h4>{t('Total KKOG')}</h4>
                                                    <h3>{bonus?.totalamount?.toFixed(2) || 0}</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <p className='BuyTknNt'>{t('Your Contribution will be calculated based on exchange rate at the moment your transaction is confirmed.')}</p>

                                        <button className='btn CmnBtn px-4 mb-5' disabled={value1 == 0 || value1 == '' || isButtonDisabled || selectedPaymentMethod === undefined}
                                            onClick={toggleWdMdl}
                                        >{t('Make Payment')}</button>
                                        <div className='ByTknInfoDv'>
                                            <img className="ByTknInfoDvIg" src={require('../../assets/images/info-circle.svg').default} alt='' />
                                            <span>{t('Tokens will appear in your account after payment successfully made and approved by our team. Please note that, KKOG Token will be distributed after the token sales end-date.')} </span>
                                        </div>


                                    </TabPane>

                                </TabContent>




                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4  CustPad">
                        <div className="DshbrdCnBlDts">
                            <div className="DshbrdCnBlDtsTp">
                                <img src={require('../../assets/images/kkogcoin.png')} alt="" className='mr-2' />
                                <div>
                                    <h6>{t('Coin Balance')}</h6>
                                    <h4>{isLoading ? '' : parseFloat(getProfie?.balance?.currencyBalance).toFixed(8)} <span>KKOG</span></h4>
                                </div>
                            </div>
                            <div className='DshbrdCnBlDtsCntr'>
                                <label>{t('You Contribution in')}</label>
                                {getCurrency?.data?.length > 0 && (
                                    <div className='DshbrdCnBlDtsCntrFlx'>
                                        <UncontrolledDropdown className="HdrCntryDD">
                                            <DropdownToggle className="HdrCntryDDBg">
                                                <img src={chooseCurrency?.currency_details?.image} alt="" />
                                                <span className='mx-2'>{chooseCurrency?.currency_details?.currency_code}</span>
                                                <img src={require('../../assets/images/down-arrow-white.png')} alt="" className="ArwDwn" />
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu-right">
                                                {getCurrency?.data?.map((currency, index) => (
                                                    <DropdownItem key={currency?._id} onClick={() => handleChooseCurrency(currency)}>
                                                        <img src={currency?.currency_details?.image} alt="" />
                                                        <span className='ml-2'>{currency?.currency_details?.currency_code}</span>
                                                    </DropdownItem>
                                                ))}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                        <h4>{listCurrency?.totalAmount == undefined ? 0 :  parseFloat(listCurrency?.totalAmount).toFixed(8)} <span>{chooseCurrency?.currency_details?.currency_symbol}</span></h4>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='ByTknsls'>
                            <div className='ByTknslsTp'>
                                <h4>{t('Token Sales Progress')}</h4>
                            </div>
                            <div className='ByTknslsBtm'>

                                <div className='ByTknslsBtmDts'>
                                    <label>KKOG {t('Coin Price')}</label>
                                   
                                        {activeTab === '1' ?  <h4>  1 KKOG = {selectcrypto?.kkogprice ? ( selectcrypto.kkogprice).toFixed(6) : 0} {selectcrypto?.currency_details?.currency_symbol ?? ''} </h4> :
                                        <h4> 1 KKOG = {selectedCurrency?.kkogprice ? (selectedCurrency.kkogprice).toFixed(6) : 0} {selectedCurrency?.currency_details?.currency_symbol ?? ''} </h4>
                            }
                                       
                                </div>


                                <div className='ByTknslsBtmDts'>
                                    <label>{t('Exchange Rate')}</label>

                                    {activeTab === '1' ? 
                                     <h4>
                                     {selectcrypto?.kkogprice && selectcrypto?.currency_details?.usd_price
                                         ? `1 KKOG = ${(selectcrypto.kkogprice).toFixed(6)} ${selectcrypto.currency_details.currency_symbol} = ${(selectcrypto.currency_details.usd_price).toFixed(2)} USD`
                                         : '1 KKOG = 0 USD'
                                     }
                                 </h4>
                                    :
                                    <h4>
                                        {selectedCurrency?.kkogprice && selectedCurrency?.currency_details?.usd_price
                                            ? `1 KKOG = ${(selectedCurrency.kkogprice).toFixed(2)} ${selectedCurrency.currency_details.currency_symbol} = ${(selectedCurrency.currency_details.usd_price).toFixed(2)} USD`
                                            : '1 KKOG = 0 USD'
                                        }
                                    </h4>
}
                                </div>
                               
                             

 {(() => {
 
//  Extracted logic
let endSection = null;

if (presaleActive && visible) {
  endSection = (
    <div className='Ldv'>
      <label>{t('End at')}</label>
      <h6>{formatDate(endtime)}</h6>
    </div>
  );
}

return (
  <div className='ByTknslsBtmDtsFlx'>
    <div className='Ldv'>
      <label>{t('Current Bonus')}</label>
      <h3>{visible ? presalevalue : 0} %</h3>
    </div>

    {endSection}
  </div>
);
 
 

  })()}
                            </div>
                        </div>

                        {presaleActive ?
                            <div className='DshbrdTknslPrgs'>
                                <div className='DshbrdTknslPrgsTp'>
                                    <h4>{t('Token Sales Progress')}</h4>
                                </div>

                                <div className='DshbrdTknAmt'>
                                    <div className='Ldv'>
                                        <h6>{t('Raised Amount')}</h6>
                                        <p>{(getPreSales?.data?.totalPurchased || 0)} KKOG</p>
                                    </div>
                                    <div className='Rdv'>
                                        <h6>{t('Total Token')}</h6>
                                        <p>{getPreSales?.data?.totalPreSupply} KKOG</p>
                                    </div>
                                </div>

                                <div className='DshbrdTknPrgsDv'>
                                    <div className="progress">
                                        <div className="progress-bar" style={{ width: `${presalePercentage}%` }} />
                                    </div>
                                </div>

                                {visible ?
                                    <div className='DshbrdSlEdDv'>
                                        <label>{t('Sales End in')}</label>
                                        <div className='BnrTmr'>
                                            <div className="BnrTmrDv">
                                                <div className='Ldv'>
                                                    <h4>{days}</h4>
                                                    <h6>{t('Days')}</h6>
                                                </div>
                                                <div className='Rdv'>:</div>
                                                <div className='Ldv'>
                                                    <h4>{hours}</h4>
                                                    <h6>{t('Hours')}</h6>
                                                </div>
                                                <div className='Rdv'>:</div>
                                                <div className='Ldv'>
                                                    <h4>{minutes}</h4>
                                                    <h6>{t('Minutes')}</h6>
                                                </div>
                                                <div className='Rdv'>:</div>
                                                <div className='Ldv'>
                                                    <h4>{seconds}</h4>
                                                    <h6>{t('Seconds')}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                            </div>

                            : <div className='DshbrdTknslPrgs'>
                                <div className='DshbrdTknslPrgsTp'>
                                    <h4>{t('Token Sales Progress')}</h4>
                                </div>

                                <div className='DshbrdTknAmt'>
                                    <div className='Ldv'>
                                        <h6>{t('Raised Amount')}</h6>
                                        <p>{(getSalesProgress?.data?.totalPurchased || 0)} KKOG</p>
                                    </div>
                                    <div className='Rdv'>
                                        <h6>{t('Total Token')}</h6>
                                        <p>{getSalesProgress?.data?.totalSupply} KKOG</p>
                                    </div>
                                </div>

                                <div className='DshbrdTknPrgsDv'>
                                    <div className="progress">
                                        <div className="progress-bar" style={{ width: `${salePercentage}%` }} />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <Modal isOpen={isedit} toggle={toggleEdit} className='CmnMdl modal-dialog-centered'>
                    <div className='MdlHdr'>
                        <h5>{selectedPaymentMethod?.split('_').join(' ')} {t('Payment Form')}</h5>
                        <button className='EpySty' onClick={toggleEdit}><img src={require('../../assets/images/close-circle.png')} alt='' /></button>

                    </div>
                    <ModalBody className='MdlBdy WDMdlBody'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='WdMdlFrmGrp'>

                                <div className='mt-2'>
                                    <Label className='pay-label'>{t('Phone Number')}</Label>
                                    <input name='phoneNumber'
                                        type='text'
                                        {...register('phoneNumber')}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/\D/g, '');
                                        }}
                                        className='form-control' />
                                    {errors.phoneNumber && <p className="text-danger">{errors.phoneNumber.message}</p>}
                                </div>
                                <div className='mt-2'>
                                    <Label className='pay-label'>{t('Amount')}</Label>
                                    <input name='amount'
                                        type='text'
                                        {...register('amount')}
                                        value={parseFloat(inrAmount)}
                                        readOnly
                                        className='form-control' />
                                    {errors.amount && <p className="text-danger">{errors.amount.message}</p>}
                                </div>
                                <div className='mt-2'>
                                    <Label className='pay-label'>{t('Reference')}</Label>
                                    <input name='reference'
                                        type='text'
                                        {...register('reference')}
                                        className='form-control' />
                                    {errors.reference && <p className="text-danger">{errors.reference.message}</p>}
                                </div>
                                <div className="form-group">
                                    <button className='btn PayBtn w-100 h-46'>{t('Pay Now')}</button>
                                </div>
                            </div>

                        </form>
                    </ModalBody>
                </Modal>


                <Modal isOpen={modal} toggle={toggleCnWal} className='CmnMdl modal-dialog-centered'>
                    <div className='MdlHdr'>
                        <h5>Connect Wallet</h5>
                        <button className='EpySty' onClick={toggleCnWal}><img src={require('../../assets/images/close-circle.png')} alt='' /></button>
                    </div>
                    <ModalBody className='MdlBdy CnWalMdlBody'>
                        <div className='CnWalMdlBodyDv'>
                            <button onClick={onConnectWalletClick} style={{ all: 'unset', cursor: "pointer" }} disabled={isloading}>

                                <img src={require('../../assets/images/metamask.png')} alt='' />
                            </button>
                            <h5>Metamask</h5>
                        </div>
                        <p>Start by connecting with Metamask Wallet & Be sure to store your private keys</p>
                    </ModalBody>
                </Modal>




                <Modal isOpen={paymentModal} toggle={toggleWdMdl} className='CmnMdl modal-dialog-centered'>
                <div className='MdlHdr'>
                        <button className='EpySty' onClick={toggleWdMdl}><img src={require('../../assets/images/close-circle.png')} alt='' /></button>
                    </div>
 <ModalBody className='MdlBdy'>
 <img src={require('../../assets/images/comingsoon.png')} alt='' className='d-block m-auto'/>
 </ModalBody>
 </Modal>
            </div>
        </>
    );
}

export default BuyToken;